import { RootState } from '@src/store/store'
import { AuthStateType, initialState } from './reducer'

export const selectAuth = (state: RootState):AuthStateType => state.isAuth || initialState

export const selectIsLoading = (state: RootState): boolean => selectAuth(state).isLoading
export const selectIsAuth = (state: RootState): boolean => selectAuth(state).isAuth
export const selectRegisterSuccess = (state: RootState): boolean => selectAuth(state).registerSuccess
export const selectChangePasswordSuccess = (state: RootState): boolean => selectAuth(state).changePasswordSuccess
export const selectBackError = (state: RootState) => selectAuth(state).backError
export const selectIsRecallPasswordNoUser = (state: RootState) => selectAuth(state).isRecallPasswordNoUser
export const selectIsSuccessRecallPassword = (state: RootState) => selectAuth(state).isSuccessRecallPassword
export const selectIsSuccessRecoveryPassword = (state: RootState) => selectAuth(state).isSuccessRecoveryPassword
export const selectUserData = (state: RootState) => selectAuth(state).newUserData
